import { createSlice } from '@reduxjs/toolkit';

const MachineNoteDetailsDataSlice = createSlice({
    name: 'MachineNoteDetailsData',
    initialState: '',
    reducers: {
        setMachineNoteDetailsData: (state, action) => {
            return action.payload;
        },
    },
});

export const { setMachineNoteDetailsData } = MachineNoteDetailsDataSlice.actions;
export default MachineNoteDetailsDataSlice.reducer;